export default __webpack_public_path__ + "static/media/idea-web-2.bbe2afa2.png";